import { LandingPageWrapper, LandingPageWrapperMobile } from "./styles/LandingPage.styles";
import { LandingPageCarousel } from "./components/LandingPageCarousel";
import { LandingPageForm } from "./components/LandingPageForm";
import { LandingPageLogin } from "./components/LandingPageLogin";
import { useIsMobile } from "src/utils/hooks/useIsMobile";
import { SIGN_UP_STAGE } from "src/store/features/signUpForm.slice";
import { useSignUpFormSlice } from "src/store/features/signUpForm.slice";
import { useLocation } from "react-router-dom";

export function LandingPage() {
  const isMobile = useIsMobile();
  const location = useLocation();

  // Determine mode based on current path.
  // the landingpage is used for both login and signup. the mode will only ever be "signup" when the path is signup,
  // all other instances it should show login (there are many instances where login is shown so thats why its the default)
  const mode = location?.pathname?.toLowerCase() === "/signup" ? "signup" : "login";

  const { signUpStage } = useSignUpFormSlice();
  const isFullScreen = signUpStage === SIGN_UP_STAGE.SUBSCRIPTION;

  // when isMobile, we want the carousel to be on the bottom of the page
  // when not isMobile, we want the carousel to be on the left of the page.
  // if we were to use Grid logic, the carousel would be put on top of the login/signup form.
  // this is why we specifically check for isMobile to change how the Carousel and Login/Signup Form are displayed.
  if (mode === "login") {
    return isMobile ? (
      <LandingPageWrapperMobile>
        <LandingPageLogin />
        {!isFullScreen && <LandingPageCarousel isMobile={isMobile} mode={mode} />}
      </LandingPageWrapperMobile>
    ) : (
      <LandingPageWrapper container spacing={0}>
        {!isFullScreen && <LandingPageCarousel isMobile={isMobile} mode={mode} />}
        <LandingPageLogin />
      </LandingPageWrapper>
    );
  }

  return isMobile ? (
    <LandingPageWrapperMobile>
      <LandingPageForm />
      {!isFullScreen && <LandingPageCarousel isMobile={isMobile} mode={mode} />}
    </LandingPageWrapperMobile>
  ) : (
    <LandingPageWrapper container spacing={0}>
      {!isFullScreen && <LandingPageCarousel isMobile={isMobile} mode={mode} />}
      <LandingPageForm />
    </LandingPageWrapper>
  );
}
